'use client';

import { c as _c } from "react/compiler-runtime";
import { type ComponentPropsWithoutRef, forwardRef } from 'react';
import { useCarouselContext } from './context';
import { mergeProps } from './utils/mergeProps';
export interface CarouselButtonProps extends Omit<ComponentPropsWithoutRef<'button'>, 'dir'> {
  /** Direction that the carousel should scroll when clicked. */
  dir: 'next' | 'prev';
}
export const CarouselButton = forwardRef<HTMLButtonElement, CarouselButtonProps>(function CarouselButton(t0, forwardedRef) {
  const $ = _c(3);
  const {
    dir,
    ...props
  } = t0;
  const {
    carouselState
  } = useCarouselContext();
  const buttonProps = dir === "prev" ? carouselState?.prevButtonProps : carouselState?.nextButtonProps;
  const t1 = "button";
  const t2 = mergeProps(buttonProps, props);
  let t3;
  if ($[0] !== forwardedRef || $[1] !== t2) {
    t3 = <button ref={forwardedRef} type={t1} {...t2} />;
    $[0] = forwardedRef;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
});